(function($) {
    function StickyToolbar(toolbar, extraBlock, config) {
        var self = this;

        this.config     = $.extend({}, this.__defaultConfig, config || {});
        this.toolbar    = $(toolbar);
        this.extraBlock = $(extraBlock);
        this.$w         = $(window);
        this.body       = $('body:first');

        this.extraBlockHeight      = this.extraBlock.outerHeight();
        this.toolbarHeight         = this.toolbar.outerHeight();
        this.toolbarInitialTop     = this.toolbar.position().top;
        this.scrollTop             = Math.max(this.$w.scrollTop(), 0);
        this.extraBlockTopDelta    = 0;

        this.$w.on('scroll load', function() {
            self.recalculateStates();
        });
    }

    StickyToolbar.prototype.__defaultConfig = {
        fixedClass: 'is-fixed'
    };

    StickyToolbar.prototype.resetPosition = function() {
        this.body.css('padding-top', 0);
        this.extraBlock
            .removeClass(this.config.fixedClass)
            .css('margin-top', 0);
        this.toolbar
            .removeClass(this.config.fixedClass)
            .css('margin-top', 0);
    };

    StickyToolbar.prototype.setPosition = function(toolbarTop) {
        this.body.css('padding-top', (this.extraBlockHeight + this.toolbarHeight) + 'px');
        this.toolbar
            .addClass(this.config.fixedClass)
            .css('margin-top', toolbarTop + 'px');
        this.extraBlock
            .addClass(this.config.fixedClass)
            .css('margin-top', toolbarTop + 'px');
    };

    StickyToolbar.prototype.recalculateStates = function() {
        var scrollTop = Math.min(
            Math.max(this.$w.scrollTop(), 0),
            document.body.clientHeight - (window.innerHeight || 0)
        );

        this.extraBlockTopDelta -= (scrollTop - this.scrollTop);
        if (this.extraBlockTopDelta > this.extraBlockHeight) {
            this.extraBlockTopDelta = this.extraBlockHeight;
        } else if (this.extraBlockTopDelta < 0) {
            this.extraBlockTopDelta = 0;
        }

        var toolbarTop = scrollTop + this.extraBlockTopDelta;
        if (toolbarTop <= this.toolbarInitialTop) {
            this.resetPosition();
        } else {
            this.setPosition(this.extraBlockTopDelta);
        }

        this.scrollTop = scrollTop;
    };

    $.fn.StickyToolbar = function(extraBlock, config) {
        this.each(function() {
            new StickyToolbar(this, extraBlock, config);
        });
    }
})(jQuery);

